module.exports = __webpack_public_path__ + "img/banner.8ce68d2a.png";